@use 'src/core/styles/mediaQueries';
@use 'src/core/styles/variables';

// ANIMATIONS ==========================================================================================================

@keyframes opacityFadeIn {
  0% {
    opacity: 0;
  }

  25% {
    opacity: 0.1;
  }

  50% {
    opacity: 0.25;
  }

  75% {
    opacity: 0.4;
  }

  100% {
    opacity: 0.5;
  }
}

@keyframes fadeInFromBottom {
  from {
    transform: translateY(100%);
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeOutToBottom {
  from {
    opacity: 1;
  }

  to {
    transform: translateY(100%);
    opacity: 0;
  }
}

@keyframes slideFromRight {
  from {
    transform: translateX(100%);
  }

  to {
    right: 0;
  }
}

@keyframes slideRight {
  from {
    right: 0;
  }

  to {
    transform: translateX(100%);
  }
}

// MODAL STYLES ========================================================================================================

.modalWrapper {
  display: flex;
  visibility: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition:
    visibility 0.2s,
    opacity 0.2s ease-in;
  opacity: 0;

  &:not(.fullScreenMobile) {
    align-items: center;
    justify-content: center;
  }

  &.open {
    visibility: visible;
    z-index: 1300;
    opacity: 1;
  }

  &.rightHalfScreen {
    justify-content: flex-end;
  }

  &.fullScreen {
    align-items: unset;
    justify-content: unset;
  }

  &.fullScreenMobile {
    @include mediaQueries.above-mobile {
      align-items: center;
      justify-content: center;
    }
  }

  &.bottomHalfScreen {
    align-items: flex-end;
  }

  &.bottomHalfScreenMobile {
    align-items: flex-end;

    @include mediaQueries.above-mobile {
      align-items: center;
    }
  }
}

.modalBackDrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.3s ease-in;
  opacity: 0;
  background-color: var(--grey-600);

  &.open {
    opacity: 0.5;
  }
}

.modalCard {
  position: relative;
  z-index: 100; // ensure modalCard is on same z-index plane as modalWrapper
  width: 100%;
  overflow-y: auto;
  animation: fadeOutToBottom 0.3s ease-out;
  background: var(--white-100);

  @include mediaQueries.above-mobile {
    max-width: 600px;
    margin: 0;

    &.defaultPadding {
      padding: 48px;
    }

    &.largeDesktopSize {
      max-width: 1000px;
    }
  }

  &:not(.fullScreenMobile) {
    max-height: 90vh; // to prevent modal card from blowing past height of application if content grows vertically
    margin: 0 16px; // adds left/right spacing to horizontal edges of screen
    border-radius: 4px;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
  }

  &.defaultPadding {
    padding: 48px 16px;
  }

  &.open {
    animation: fadeInFromBottom 0.3s ease-out;
  }

  &.fullScreen {
    max-width: unset;
    max-height: 100vh;
    margin: 0;
    border-radius: 0;
  }

  &.rightHalfScreen {
    max-width: unset;
    max-height: 100vh;
    margin: 0;
    animation: slideRight 0.3s ease-in-out;
    border-radius: 0;

    @include mediaQueries.above-mobile {
      top: 0;
      max-width: 788px;
      min-height: 100%;
      margin: 0;
      padding: 0;
      padding-top: 40px;
      border-radius: 0;
    }

    &.open {
      animation: slideFromRight 0.3s ease-out;
    }
  }

  &.fullScreenMobile {
    padding: 48px 16px;

    @include mediaQueries.above-mobile {
      max-height: 90vh;
      margin: 0 16px;
      padding: 48px;
    }
  }

  &.noPadding {
    padding: 0;
  }

  &.bottomHalfScreen {
    max-height: 60%;
    margin: 0;
    border-radius: 4px 4px 0 0; // round the top-left/top-right borders
  }

  &.bottomHalfScreenMobile {
    max-height: 60%;
    margin: 0;
    padding: 48px 16px;
    border-radius: 4px 4px 0 0;

    @include mediaQueries.above-mobile {
      margin: 0 16px;
      padding: 48px;
      border-radius: 4px;
    }
  }
}

.closeModalButton {
  position: absolute;
  z-index: 1;
  top: 16px;
  right: 16px;
}
